import sliceCreator from '../../index.js';
import {PR_GET_ORDER} from '../../../constants/index.js';
const _prGetOrderAction = sliceCreator('PR_GET_ORDER',PR_GET_ORDER, 'get');

const { asyncAction: prGetOrderAction, reducer, clearData: clearprGetOrderData } = _prGetOrderAction;

export default reducer;

export {
    prGetOrderAction,
    clearprGetOrderData
}


